<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Accueil</router-link></li>
        <li
          class="breadcrumb-item active"
          aria-current="page">Suivi client</li>
      </ol>
    </nav>
    <b-container>
      <b-row>
        <b-col>
          <b-form-group
            label="Filtrer"
            label-cols-sm="3"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput">
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Taper pour rechercher un établissement"/>
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''">Effacer</b-button>
              </b-input-group-append>
            </b-input-group>

            <b-form-select
              v-model="period"
              :options="optionsPeriod"
              size="sm"
              class="mt-3"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        :fields="fields"
        :items="establishments"
        :filter="filter"
        :filter-included-fields="filterOn"
        small
        responsive="sm">

        <template #cell(thead-top)="data">
          <b-tr>
            <b-th
              variant="secondary"
              colspan="3">Etablissement</b-th>
            <b-th
              :colspan="numberColumnsMonitoring"
              variant="secondary">Suivi Usage</b-th>
            <b-th
              variant="secondary"
              colspan="1">Indicateur</b-th>
          </b-tr>
        </template>

        <template #cell(HEAD[logistic])="data">
          <b-badge
            :variant="collapseLogistic ? 'primary' : 'secondary'"
            @click="toggleColumnsLogistic(collapseLogistic)"><font-awesome-icon
              :icon="collapseLogistic ? ['fas', 'minus'] : ['fas', 'plus']"
              class=""/></b-badge>
          {{ data.label }}
        </template>

        <template #cell(HEAD[manage])="data">
          <b-badge
            :variant="collapseManage ? 'primary' : 'secondary'"
            @click="toggleColumnsManage(collapseManage)"><font-awesome-icon
              :icon="collapseManage ? ['fas', 'minus'] : ['fas', 'plus']"
              class=""/></b-badge>
          {{ data.label }}
        </template>

        <template #cell(HEAD[patgames])="data">
          <b-badge
            :variant="collapsePatGames ? 'primary' : 'secondary'"
            @click="toggleColumnsPatGames(collapsePatGames)"><font-awesome-icon
              :icon="collapsePatGames ? ['fas', 'minus'] : ['fas', 'plus']"
              class=""/></b-badge>
          {{ data.label }}
        </template>

        <template #cell(esta_name)="row">
          <b-button
            :to="{ name: 'StatsEstablishment', params: { id: row.item.esta_id } }"
            variant="outline-primary">
            {{ row.item.esta_name }}
          </b-button>
        </template>

        <template #cell(logistic)="row">
          <font-awesome-icon
            :icon="['fas', 'circle']"
            :style="{ color: row.item.logistic }"
            class=""/>
        </template>

        <template  #cell(manage)="row">
          <font-awesome-icon
            :icon="['fas', 'circle']"
            :style="{ color: row.item.manage }"
            class=""/>
        </template>

        <template #cell(patgames)="row">
          <font-awesome-icon
            :icon="['fas', 'circle']"
            :style="{ color: row.item.patgames }"
            class=""/>
        </template>

        <template #cell(global)="row">
          <font-awesome-icon
            :icon="['fas', 'circle']"
            :style="{ color: row.item.global }"
            class=""/>
        </template>
      </b-table>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'StatsEstablishments',
  components: {},
  data() {
    return {
      fields: [
        {
          esta_name: {
            label: 'Nom',
            sortable: true,
            tdClass: 'align-middle',
            stickyColumn: true,
          },
        },
        {
          esta_postalcode: {
            label: 'Département',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          off_name: {
            label: 'Offre',
            sortable: true,
            tdClass: 'align-middle',
            filterByFormatted: true,
          },
        },
        {
          logistic: {
            label: 'Logistique',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          avglastsyn: {
            label: 'Dernière synchro',
            sortable: true,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          nbsyncdevices: {
            label: 'Nb tablettes',
            sortable: true,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          manage: {
            label: 'Outil de gestion',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          nbexternalsessions: {
            label: 'Séances externes',
            sortable: true,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          nbevents: {
            label: 'Evnts. créés',
            sortable: true,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          reports: {
            label: 'Cpts rendus',
            sortable: true,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          patgames: {
            label: 'PatGames',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          nbpatgamessessions: {
            label: 'Nb de séances',
            sortable: false,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          nballactivities: {
            label: 'Nb d\'activités',
            sortable: true,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          time: {
            label: 'Tps passé',
            sortable: true,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          participants: {
            label: 'Résidents',
            sortable: true,
            thClass: 'd-none',
            tdClass: 'align-middle, d-none',
          },
        },
        {
          global: {
            label: 'Trier',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
      ],
      collapseLogistic: false,
      collapseManage: false,
      collapsePatGames: false,
      filter: null,
      filterOn: ['esta_name'],
      numberColumnsMonitoring: 3,
      period: 1,
      optionsPeriod: [
        { value: 1, text: '1 mois' },
        { value: 2, text: '2 mois' },
        { value: 3, text: '3 mois' },
        { value: 4, text: '4 mois' },
      ],
    };
  },
  computed: {
    ...mapState({
      establishments: state => state.establishments.statsEstablishments,
      slidingPeriodStatsEstablishments: state => state.establishments.slidingPeriodStatsEstablishments,
    }),
  },
  watch: {
    period: {
      handler(val) {
        this.changeSlidingPeriodStatsEstablishments(val);
      },
    },
    slidingPeriodStatsEstablishments: {
      handler() {
        this.getStatsEstablishments();
      },
    },
  },
  created() {
    // this.$store.dispatch('establishments/getStatsEstablishments')
  },
  mounted() {
    this.getStatsEstablishments();
  },
  methods: {
    ...mapActions({
      getStatsEstablishments: 'establishments/getStatsEstablishments',
      changeSlidingPeriodStatsEstablishments: 'establishments/changeSlidingPeriodStatsEstablishments',
    }),
    hideColumn(index, name) {
      this.fields[index][name].thClass = 'd-none';
      this.fields[index][name].tdClass = 'align-middle, d-none';
    },
    showColumn(index, name) {
      this.fields[index][name].thClass = '';
      this.fields[index][name].tdClass = 'align-middle';
    },
    toggleColumnsLogistic() {
      const index1 = this.fields.findIndex(e => Object.keys(e).includes('avglastsyn'));
      const index2 = this.fields.findIndex(e => Object.keys(e).includes('nbsyncdevices'));
      if (!this.collapseLogistic) {
        this.showColumn(index1, 'avglastsyn');
        this.showColumn(index2, 'nbsyncdevices');
        this.numberColumnsMonitoring += 2;
      } else {
        this.hideColumn(index1, 'avglastsyn');
        this.hideColumn(index2, 'nbsyncdevices');
        this.numberColumnsMonitoring -= 2;
      }

      this.collapseLogistic = !this.collapseLogistic;
    },
    toggleColumnsManage() {
      const index1 = this.fields.findIndex(e => Object.keys(e).includes('nbexternalsessions'));
      const index2 = this.fields.findIndex(e => Object.keys(e).includes('nbevents'));
      const index3 = this.fields.findIndex(e => Object.keys(e).includes('reports'));
      if (!this.collapseManage) {
        this.showColumn(index1, 'nbexternalsessions');
        this.showColumn(index2, 'nbevents');
        this.showColumn(index3, 'reports');
        this.numberColumnsMonitoring += 3;
      } else {
        this.hideColumn(index1, 'nbexternalsessions');
        this.hideColumn(index2, 'nbevents');
        this.hideColumn(index3, 'reports');
        this.numberColumnsMonitoring -= 3;
      }

      this.collapseManage = !this.collapseManage;
    },
    toggleColumnsPatGames() {
      const index1 = this.fields.findIndex(e => Object.keys(e).includes('nbpatgamessessions'));
      const index2 = this.fields.findIndex(e => Object.keys(e).includes('nballactivities'));
      const index3 = this.fields.findIndex(e => Object.keys(e).includes('time'));
      const index4 = this.fields.findIndex(e => Object.keys(e).includes('participants'));
      if (!this.collapsePatGames) {
        this.showColumn(index1, 'nbpatgamessessions');
        this.showColumn(index2, 'nballactivities');
        this.showColumn(index3, 'time');
        this.showColumn(index4, 'participants');
        this.numberColumnsMonitoring += 4;
      } else {
        this.hideColumn(index1, 'nbpatgamessessions');
        this.hideColumn(index2, 'nballactivities');
        this.hideColumn(index3, 'time');
        this.hideColumn(index4, 'participants');
        this.numberColumnsMonitoring -= 4;
      }

      this.collapsePatGames = !this.collapsePatGames;
    },
  },
};
</script>
<style>

</style>
